import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Elbolag = lazy(() => import("@/pages/Elbolag"));

export const Route = createFileRoute("/elbolag/")({
  head: () => seoHead("/elbolag"),
  component: () => <Elbolag />,
});
